import React from 'react';
import { Controller } from 'react-hook-form';
import { IncomeOptionsDTO } from '../../../api/useIncomeQuery';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';

export const EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE = -1;
const excludeOption = {
  label: 'Exclude from Asset Bucketing',
  value: EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE,
};

interface Props {
  control: any;
  fieldName: string;
  managementStyleValue: number | null;
  options: IncomeOptionsDTO;
}

export const AssetBucket = ({
  control,
  fieldName,
  managementStyleValue,
  options: baseOptions,
}: Props) => {
  const {
    AvailableAssetBuckets,
    AllowAssetBucketingCustomization,
    AssetBucketingByManagementStyle,
    DisplayAssetBucketing,
  } = baseOptions;

  if (!DisplayAssetBucketing) {
    return null;
  }

  const bucketOptions = AvailableAssetBuckets.map(({ Title, ManagementStyles }, index) => ({
    label: Title,
    value: index,
    managementStyleList: ManagementStyles,
  }));

  const defaultAssetBucket = bucketOptions.find(option => {
    return (
      managementStyleValue !== null && option.managementStyleList.includes(managementStyleValue)
    );
  });

  const options = [...bucketOptions, excludeOption].map(option => {
    const isDefault = defaultAssetBucket
      ? option.value === defaultAssetBucket.value
      : option.value === EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE;

    return {
      ...option,
      rightLabel: isDefault ? 'Default' : undefined,
    };
  });

  const isDisabled =
    (AssetBucketingByManagementStyle && managementStyleValue === null) ||
    !AllowAssetBucketingCustomization;

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            label="Asset Bucketing"
            value={options.find(({ value: v }) => v === value)}
            options={options}
            onChange={option => onChange(option?.value)}
            placeholder={isDisabled ? 'Select Management Style' : 'Select Asset Bucketing'}
            disabled={isDisabled}
            isPortal
          />
        );
      }}
    />
  );
};
